import { cva } from 'class-variance-authority';

export const logo = cva('', {
  variants: {
    logo: {
      essence: 'w-12 lg:w-16',
      cigna: 'w-12 lg:w-16', // TODO: update when we get the cropped image
      'olympics-team-usa': '',
      'us-open-tennis': '',
      undefined: '',
    },
  },
});
